import { render, staticRenderFns } from "./grangerCheck.vue?vue&type=template&id=8842bb2a&"
import script from "./grangerCheck.vue?vue&type=script&lang=js&"
export * from "./grangerCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports